import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import parse from 'html-react-parser'
import BottomSheet from "react-draggable-bottom-sheet";
import { HandySvg } from 'handy-svg'
import IconQuestion from '@/icons/question.svg'
import ProjectDiscountComplex from './complex';
import ProjectDiscountOnce from './once';
import ProjectDiscountSimple from './simple';
import { useInitData, useWebApp } from '@vkruglikov/react-telegram-web-app';
import ProjectsApi from '../../api';
import ShareButton from '@/components/ShareButton';

export default function ProjectDiscount() {
	const location = useLocation()
  	const shop = location.state.shop
  	const coupon = location.state.coupon
	const [initDataUnsafe, initData] = useInitData();
	const WebApp = useWebApp();

	const [isRefOpen, setIsRefOpen] = useState(false);

	const refClose = () => setIsRefOpen(false);

	useEffect(() => {
		ProjectsApi.stat({
			coupon: coupon.id,
			shop: shop.id,
			initData: initData
		})
	}, [])

	return (
		<>
			<div className='boxList'>
				<div className='boxList_item'>
					<div className='boxList_item-icon'>
						{shop.image && <img src={shop.host + '/i/100x100/' + shop.image} alt='' />}
					</div>
					<div className='boxList_item-content'>
						<div className='boxList_item-title'>{shop.title}</div>
						<div className='boxList_item-hint'>{shop.category}</div>
					</div>
					{shop.url &&
						<div className='boxList_item-right'>
							<button onClick={() => {
								WebApp.openLink(shop.url)
							}} className='btn btn--sm'>Перейти</button>
						</div>
					}
				</div>
			</div>

			{shop.description &&
				<div className='boxText'>
					<div className='boxText_body'>
						{parse(shop.description)}
					</div>
				</div>
			}

			<div className='boxText'>
				<div className='boxText_header'>Описание</div>
				<div className='boxText_body'>
					<p><b>{coupon.title}</b></p>
					<p>{parse(coupon.description, {
						replace: (domNode) => {
							if (domNode.type === 'tag' && domNode.name === 'a') {
								const href = domNode.attribs?.href;
								return (
									<a href={href} onClick={(e) => {
										e.preventDefault();
										WebApp.openLink(href);
									}}>
										{domNode.children?.map((child, i) => parse(child.data || '') ?? null)}
									</a>
								);
							}
						}
					})}</p>
				</div>
			</div>

			{
				coupon.type_of_steps == 20 ?
					<ProjectDiscountComplex/>
				: coupon.type_of_steps == 10 ?
					<ProjectDiscountOnce/>
				:
					<ProjectDiscountSimple/>
			}

			<ShareButton style={{marginTop: '-31px'}} url={'CP' + coupon.id} text={shop.title + ' - ' + coupon.title} />

			<a className='btn btn--block btn--tt-none btn--light' style={{marginBottom: '8px'}} href={process.env.REACT_APP_LINK_TO_COMMENTS + coupon.id}>Комментарии ({coupon.comments_count ?? 0})</a>

			<div className='boxButtons'>
				<button className='boxButtonsItem' onClick={() => setIsRefOpen(true)}>
					<div className='boxButtonsItem-icon'>
						<HandySvg src={IconQuestion} />
					</div>
					<div className='boxButtonsItem-info'>
						<div className='boxButtonsItem-text'>Скидка или промокод не работает?</div>
					</div>
				</button>
			</div>

			<BottomSheet isOpen={isRefOpen} close={refClose}>
				<button className='BottomSheetClose' onClick={refClose}>Закрыть</button>
				<div className='BottomSheetTitle'>Помощь</div>
				<div className='boxText'>
					<div className='boxText_body'>
						<p>Если не работает скидка или не применяется промокод, сообщите нам написав комментарий под скидкой.</p>
						<p>Следите за обновлением свежих промокодов в канале Промопушка: <a href='#' onClick={(e) => {
							e.preventDefault()
							WebApp.openTelegramLink('https://t.me/joinchat/AAAAADwpXXeKpgkHAYRSlw');
						}}>https://t.me/joinchat/AAAAADwpXXeKpgkHAYRSlw</a></p>
					</div>
				</div>
			</BottomSheet>
		</>
	)
}
